import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Header, Platform } from '@aptsi-types';
import { PlatformService } from '../platform.service';
import { DeleteDialogComponent } from 'src/app/shared/dialogs/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-platform-search',
  templateUrl: './platform-search.component.html',
  styleUrls: ['./platform-search.component.scss']
})
export class PlatformSearchComponent {
totalPages = 0;
   totalPagesNormal = 0;
   totalPagesSearch = 0;
 
   itemsPerPage = 10;
   currentPage = 1;
 
  //  sessionId = this.keycloakStateService.getSessionId();
  //  userId = this.keycloakStateService.getUserId();
  //  transactionId = this.keycloakStateService.getTransactionId();
   isAdd: boolean = false;
 
   get paginatedData() {
     if (!this.isSearch) {
       const start = (this.currentPage - 1) * this.itemsPerPage;
       const end = start + this.itemsPerPage;
       return this.filteredData.slice(start, end);
     } else {
       const start = (this.currentPage - 1) * this.itemsPerPage;
       const end = start + this.itemsPerPage;
 
       return this.searchedData.slice(start, end);
     }
   }
 
   filteredData: Platform[] = [];
   searchedData: Platform[] = [];
 
   changePage(page: number) {
     this.currentPage = page;
     if (!this.isSearch) {
       this.totalPages = this.totalPagesNormal; // Ensure correct total pages
       this.fetchPlatforms();
     } else {
       this.totalPages = this.totalPagesSearch; // Ensure correct total pages
       this.fetchPlatformsSearch();
     }
   }
 
   headers: Header[] = [
     {
       name: "Platform Id",
       property: "id",
       showInDropdown: true,
       description: "Unique identifier for the zone", // Tooltip content
     },
     {
       name: "Platform Name",
       property: "name",
       showInDropdown: true,
       description: "Name of the platform",
     },
      {
       name: "Category",
       property: "category",
       showInDropdown: true,
       description: "Category of the platform",
     },

     {
       name: "Description",
       property: "description",
       showInDropdown: false,
       description: "Description of the platform",
     },
     {
       name: "Last Updated",
       property: "updatedAt",
       showInDropdown: true,
       description: "Timestamp of the most recent update",
     },
   ];
   searchText: string = ""; // Initialize to an empty string
   filterByHeader: string = "all"; // Default to "all" to show all categories
   platform: Platform[] = [];
   nullver: number = 1;
   isSearch: boolean = false;
 
 
   constructor(
     private router: Router,
     private route: ActivatedRoute,
     private platformService: PlatformService,
     private dialog: MatDialog,
     //private keycloakStateService: KeycloakStateService
   ) { }
 
   ngOnInit(): void {
 
     this.route.queryParams.subscribe((params) => {
       if (params["isAdd"] === "true") {
         this.isAdd = true;
       }
     });
 
     this.fetchPlatforms();
 
   }
 
   handleAction(event: { action: string; rowIndex: number; rowData: any }) {
     console.log(` Row Index: ${event.rowIndex}`, event.rowData);
 
     if (event.action === "update") {
       //this.updateRow(event.rowIndex, event.rowData);
       this.updatePlatform(event.rowIndex);
     } else if (event.action === "delete") {
       this.deletePlatform(event.rowIndex);
     } 
   }
 
   buttonConfig = {
     update: true,
     delete: true,
     import: false,
     configure: false,
   };
 
   async fetchPlatforms() {
     try {
       const response = await this.platformService
         .getPlatforms(this.currentPage - 1)
         .toPromise();
       //this.platforms = response;
       this.filteredData = [...response];
 
       if (response.length > 0 && response[0].totalPages) {
         this.totalPagesNormal = response[0].totalPages;
         this.totalPages = this.totalPagesNormal; // Sync `totalPages` with `totalPagesNormal`
         this.currentPage = response[0].currentPage + 1;
       }
     } catch (error) {
       console.error("Error fetching platforms:", error);
     }
   }
 
   async fetchPlatformsSearch() {
     try {
       const response = await this.platformService
         .getPlatformsSearch(
           this.currentPage - 1,
           this.searchText,
           this.filterByHeader
         )
         .toPromise();
       this.searchedData = [...response];
       console.log(response);
       if (response.length > 0 && response[0].totalPages) {
         this.totalPagesSearch = response[0].totalPages;
         this.totalPages = this.totalPagesSearch; // Sync `totalPages` with `totalPagesSearch`
         this.currentPage = response[0].currentPage + 1;
       }
     } catch (error) {
       console.error("Error fetching platforms:", error);
     }
   }
 
   resetSearchText(): void {
     this.searchText = "";
     this.isSearch = false; // Switch to normal mode
     this.currentPage = 1; // Reset to the first page of normal data
   }
 
   onInputChange(event: Event): void {
     const input = event.target as HTMLInputElement;
     this.searchText = input.value;
   }
 
    async searchPlatforms(): Promise<void> {
     try {
       if (this.searchText) {
 
         // Default value
         if (!this.filterByHeader) {
           this.filterByHeader = "all";
         }
 
         this.isSearch = true;
 
         await this.fetchPlatformsSearch();
         this.totalPages = this.totalPagesSearch;
 
         const selectedHeader = this.headers.find(
           (h) => h.property === this.filterByHeader && h.showInDropdown
         );
 
         if (this.filterByHeader === "all") {
 
           this.searchedData = this.searchedData.filter((platform) =>
             this.headers.some((header) => {
               const value = platform[header.property];
 
               return value
                 ?.toString()
                 .toLowerCase()
                 .includes(this.searchText.toLowerCase());
             })
           );
 
         } else if (selectedHeader) {
 
           this.searchedData = this.searchedData.filter((platform) => {
             const value = platform[selectedHeader.property];
 
             return value
               ?.toString()
               .toLowerCase()
               .includes(this.searchText.toLowerCase());
           });
 
           this.searchedData.sort((a, b) =>
             a[selectedHeader.property]
               ?.toString()
               .localeCompare(b[selectedHeader.property]?.toString())
           );
 
         } else {
           this.filteredData = [];
         }
 
       } else {
 
         this.isSearch = false;
         await this.fetchPlatforms();
 
       }
     } catch (error) {
       console.error("Error during search:", error);
     }
   }
 
   addPlatform(){
      this.router.navigate(["secure-zone/platform/create"]);
   }
 
 
   async deletePlatform(index: number) {
      try {
             const dialogRef = this.dialog.open(DeleteDialogComponent, {
               data: {
                 title: "Are you sure?",
                 message: "Do you really want to delete this Platform?",
                 isConfirm: false,
               },
             });
       
             const result = await dialogRef.afterClosed().toPromise();
             if (!result) return;
       
             const platformId = this.isSearch
               ? this.searchedData[index].id
               : this.filteredData[index].id;
             if (!platformId) return;
             
             await this.platformService.deletePlatform(platformId).toPromise();
       
             this.isSearch ? this.fetchPlatformsSearch() : this.fetchPlatforms();
       
             this.dialog.open(DeleteDialogComponent, {
               data: {
                 title: "Success",
                 message: "The Platform has been deleted successfully.",
                 isConfirm: true,
               },
             });
           } catch (error) {
             console.error("Error deleting Platform:", error);
           }
   }
 
 
 
  
 
 
 
 
 
   async updatePlatform(index: number) {
       this.router.navigate(["secure-zone/platform/update",this.isSearch ? this.searchedData[index].id : this.filteredData[index].id]);
   }
 
 
 
 
 
   back() {
     try {
       if (this.isSearch) {
         this.isSearch = false;
         this.totalPages = this.totalPagesNormal; // Restore total pages for normal pagination
         this.currentPage = 1;
         this.fetchPlatforms();
       } else {
         this.router.navigate(["secure-zone"]);
       }
     } catch (error) { }
   }

   
 }
 